<template>
    <div class="export-link-wrapper">
        <span>{{value}}</span>
        <div class="copy-button ml-2">
            <b-button
                class="align-baseline"
                title="Copy"
                variant="default"
                @click="copyToClipboard"
            >
                <font-awesome-icon icon="copy"  />
            </b-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                value: null,
            };
        },
        created() {
          this.value = this.params.value;
        },
        methods: {
            async copyToClipboard() {
                try {
                    await navigator.clipboard.writeText(this.value);
                    this.successToast({text: 'Copied to clipboard successfully.' })
                } catch (err) {
                    this.errorToast({text: 'Something went wrong while copying to clipboard.'})
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .export-link-wrapper {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        span {
            text-overflow: ellipsis;
            overflow-x: hidden;
            margin-right: 10px;
        }
    }
</style>